import React from 'react';
import { Check, Circle, Mail } from 'lucide-react';

const LABEL = { unterlagen: 'Unterlagen hochgeladen', nachrichten: 'Nachricht geschrieben', zahlungen: 'Zahlungen angesehen' };
const MAIL = { gesendet: 'gesendet', fehlgeschlagen: 'nicht zugestellt', wird_gesendet: 'wird gesendet' };
const dt = (v) => (v ? new Date(v).toLocaleDateString('de-DE') : '');

// Schnellstart-Fortschritt eines Portalkontos (für die 360°-Ansicht)
export const SchnellstartStand = ({ k }) => {
  const s = k.schnellstart;
  if (!s) return null;
  const n = s.schritte.filter((x) => x.erledigt).length;
  const w = k.willkommen_mail || {};
  return (
    <div className="mt-2 pt-2 border-t border-gray-100" data-testid="stammblatt-schnellstart">
      <div className="flex flex-wrap items-center gap-x-3 gap-y-1">
        <span className="font-medium text-[#1B3A5C]" data-testid="stammblatt-schnellstart-zahl">Portal-Schnellstart: {n} von 3</span>
        {s.schritte.map((x) => (
          <span key={x.id} className={`inline-flex items-center gap-1 ${x.erledigt ? 'text-emerald-700' : 'text-gray-400'}`} data-testid={`stammblatt-schritt-${x.id}`} data-erledigt={x.erledigt ? 'ja' : 'nein'}>
            {x.erledigt ? <Check className="w-3 h-3" strokeWidth={3} /> : <Circle className="w-3 h-3" />}{LABEL[x.id]}
          </span>
        ))}
      </div>
      <p className="text-[11px] text-gray-500 mt-0.5">
        {s.ausgeblendet ? 'Willkommenskarte vom Mandanten ausgeblendet' : s.tage_rest > 0 ? `Willkommenskarte noch ${s.tage_rest} Tage sichtbar` : 'Willkommenskarte abgelaufen'}
        <span className="inline-flex items-center gap-1 ml-3" data-testid="stammblatt-willkommen-mail"><Mail className="w-3 h-3" />Willkommens-Mail: {w.status ? `${MAIL[w.status] || w.status} ${dt(w.am)}${w.sprache ? ` (${w.sprache.toUpperCase()})` : ''}` : 'noch nicht gesendet'}</span>
      </p>
    </div>
  );
};
